(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      window.DalilCart && window.DalilCart.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-scroll-top]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-share-article]');
    if (!btn) return;
    var shareData = { title: btn.getAttribute('data-title'), url: window.location.href };
    if (navigator.share) {
      navigator.share(shareData).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareData.url);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var sort = event.target.closest('[data-collection-sort]');
    if (sort) {
      var sortForm = document.getElementById('FacetFilterForm');
      if (sortForm) sortForm.submit();
      return;
    }
    var checkbox = event.target.closest('#FacetFilterForm input[type="checkbox"], #FacetFilterForm input[type="number"]');
    if (checkbox) checkbox.closest('form').submit();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-filter-open]')) {
      document.querySelectorAll('[data-filter-sidebar]').forEach(function (el) {
        el.setAttribute('data-open', 'true');
      });
      document.querySelectorAll('[data-filter-backdrop]').forEach(function (el) {
        el.setAttribute('data-open', 'true');
      });
      document.body.style.overflow = 'hidden';
      return;
    }
    if (event.target.closest('[data-filter-close]') || event.target.closest('[data-filter-backdrop]')) {
      document.querySelectorAll('[data-filter-sidebar]').forEach(function (el) {
        el.setAttribute('data-open', 'false');
      });
      document.querySelectorAll('[data-filter-backdrop]').forEach(function (el) {
        el.setAttribute('data-open', 'false');
      });
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-filter-sidebar][data-open="true"]').forEach(function (el) {
      el.setAttribute('data-open', 'false');
    });
    document.querySelectorAll('[data-filter-backdrop][data-open="true"]').forEach(function (el) {
      el.setAttribute('data-open', 'false');
    });
    document.body.style.overflow = '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var prose = document.querySelector('.product-detail__description .prose');
    if (!prose) return;
    prose.querySelectorAll('img, video, iframe').forEach(function (el) {
      el.remove();
    });
    prose.querySelectorAll('div, p').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === '') {
        el.remove();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-product-finder]');
    if (!root) return;

    var panels = root.querySelectorAll('[data-pf-panel]');
    var progressFill = root.querySelector('[data-pf-progress-fill]');
    var progressLabel = root.querySelector('[data-pf-progress-label]');
    var restartBtn = root.querySelector('[data-pf-restart]');
    var selectedFocus = null;
    var selectedNeed = null;
    var stepLabels = [];
    try {
      stepLabels = JSON.parse(root.getAttribute('data-step-labels'));
    } catch (e) {
      stepLabels = [];
    }

    function goToStep(step) {
      root.setAttribute('data-step', step);
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-pf-panel') !== String(step);
      });
      if (progressFill) progressFill.style.width = step * 25 + '%';
      if (progressLabel && stepLabels[step - 1]) progressLabel.textContent = stepLabels[step - 1];
      restartBtn.hidden = step === 1;
    }

    root.addEventListener('click', function (event) {
      var focusBtn = event.target.closest('[data-pf-focus-option]');
      if (focusBtn) {
        selectedFocus = focusBtn.getAttribute('data-focus-id');
        root.querySelectorAll('[data-pf-need-option]').forEach(function (btn) {
          btn.hidden = btn.getAttribute('data-focus-id') !== selectedFocus;
        });
        goToStep(2);
        return;
      }

      var needBtn = event.target.closest('[data-pf-need-option]');
      if (needBtn) {
        selectedNeed = needBtn.getAttribute('data-need-id');
        goToStep(3);
        return;
      }

      var freqBtn = event.target.closest('[data-pf-frequency-option]');
      if (freqBtn) {
        root.querySelectorAll('[data-pf-result]').forEach(function (result) {
          result.hidden = result.getAttribute('data-pf-result') !== selectedNeed;
        });
        goToStep(4);
        burstConfetti();
        return;
      }

      if (event.target.closest('[data-pf-restart]')) {
        selectedFocus = null;
        selectedNeed = null;
        goToStep(1);
      }
    });

    function burstConfetti() {
      var colors = ['#c5a37e', '#d8b894', '#f5f2ed'];
      for (var i = 0; i < 24; i++) {
        var piece = document.createElement('div');
        piece.className = 'pf-confetti';
        piece.style.background = colors[i % colors.length];
        piece.style.setProperty('--pf-x', (Math.random() * 300 - 150) + 'px');
        piece.style.setProperty('--pf-y', (Math.random() * 200 + 150) + 'px');
        piece.style.setProperty('--pf-r', Math.random() * 360 + 'deg');
        document.body.appendChild(piece);
        setTimeout(function (el) {
          return function () {
            el.remove();
          };
        }(piece), 1200);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-product-recommendations], .product-recommendations');
          if (content && content.innerHTML.trim()) {
            el.outerHTML = content.outerHTML;
          } else {
            el.remove();
          }
        })
        .catch(function () {
          el.remove();
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
